import { useContext } from 'react';
import {
	MarketStateNotificationsForMonthContext,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/MarketStateNotificationsForMonthProvider';
import _isEmpty from 'lodash/isEmpty';


export const useFindMarketStateNotificationsForStatDate = (statDate: string) => {

	const notifications = useContext(MarketStateNotificationsForMonthContext);

	if (_isEmpty(notifications)) return undefined;

	return notifications.find(notification => notification.statDate === statDate);
};